import { useEffect, useState } from 'react'
import { genricImageLinks } from '../../constants'
import { COLORS } from '../../constants/colors'
import { HamBurgerIcon, IconLeftArrow, ppBrokerLogo } from '../../image'
import { HamburgerIconConatiner, HeaderLeftContainer, HeaderMobileContainer, HeaderTitle, IconContainer, Link, SideDrawer, SideDrawerLinkContainer } from './HeaderMobile.style'
import { useHistory } from 'react-router'
import IntlMessages from '../utility/intlMessages'
import { getAssets } from '../../helpers/utility'

function HeaderMobile ({
  headerLink = [],
  isHomePage = false,
  logout = () => { },
  userName = '',
  profileUrl = '',
  activeTab = '',
  logo = genricImageLinks.fallbackLogo,
  headerBackground = COLORS.tapPartnerYellow,
  navigationLinks = [],
  navigationClickHandler = () => { },
  isLoggedIn = false,
  selectedLanguage = '',
  changeLanguagehandler = () => { },
  profileRenderMenu = [],
  navigateToLink = () => { },
  headerTitle,
  showBackButton = false
}) {
  const history = useHistory()
  const [isHamBurgerOpen, setHamBurgerOpen] = useState(false)

  useEffect(() => {
    if (isHamBurgerOpen) {
      const bodyStyle = document.querySelector('body').style
      bodyStyle.overflow = 'hidden'
    } else {
      const bodyStyle = document.querySelector('body').style
      bodyStyle.overflow = 'auto'
    }
    return () => {
      const bodyStyle = document.querySelector('body').style
      bodyStyle.overflow = 'auto'
    }
  }, [isHamBurgerOpen])

  const openHamburgerIcon = (e) => {
    e.stopPropagation()
    setHamBurgerOpen((item) => !item)
  }

  const closeHamBurgerIcon = () => {
    setHamBurgerOpen(false)
  }

  const goBack = () => {
    history.goBack()
  }

  return (
    <>
      <HeaderMobileContainer id="mobile-header" backgroundColor={getAssets().headerBackgroundColor || ''}>
        {
          !isLoggedIn &&
          <IconContainer>
            <img src={getAssets().logoUrl || ppBrokerLogo} />
          </IconContainer>
        }
        <HeaderLeftContainer>
          {
            showBackButton &&
            <IconContainer>
              <img src={getAssets().IconLeftArrow || IconLeftArrow} onClick={goBack} />
            </IconContainer>
          }
          <HeaderTitle color={getAssets().headerTextColor || ''}>
            <IntlMessages id={headerTitle || ' '} />
          </HeaderTitle>
        </HeaderLeftContainer>
        <HamburgerIconConatiner onClick={openHamburgerIcon}>
          <img src={getAssets().hamburgerIcon || HamBurgerIcon} />
        </HamburgerIconConatiner>
      </HeaderMobileContainer>
      {
        isHamBurgerOpen
          ? (
            <SideDrawer onClick={closeHamBurgerIcon}>
              <SideDrawerLinkContainer backgroundColor={getAssets().headerBackgroundColor || ''}>
                {
                  headerLink.map(({ title, link, name, action, render, closeAtAction }) => {
                    return (
                      <Link
                        key={title}
                        color={getAssets().headerTextColor || ''}
                        onClick={(e) => {
                          e.stopPropagation()
                          if (action) {
                            action()
                            if (closeAtAction) closeHamBurgerIcon()
                            return
                          }
                          closeHamBurgerIcon()
                          navigateToLink({ e, link, name, action })
                        }
                        }>
                        <IntlMessages id={title || ' '} />
                        {render && render()}
                      </Link>
                    )
                  })
                }
              </SideDrawerLinkContainer>
            </SideDrawer>
          )
          : null
      }
    </>
  )
}

export default HeaderMobile
